<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('logo_img_lnk')" prop="img_lnk">
                    <myUploadCompressedPic @getCompressImgAddr="setImgLnk" :lrz_flag="false" path="org/info"></myUploadCompressedPic>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('code')" prop="org_code">
                            <Input v-model="formData.org_code" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cname')" prop="org_cname">
                            <Input v-model="formData.org_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('mod_cname')" prop="mod_id">
                            <Select v-model="formData.mod_id" :placeholder="$t('select')">
                                <Option :value="item.mod_id" v-for="item in mods" :key="item.mod_id">{{item.mod_cname}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="org_level == '2'">
                        <FormItem :label="$t('org_grade')">
                            <Select v-model="formData.org_grade" :placeholder="$t('select')">
                                <Option :value="item.key" v-for="item in org_grade" :key="item.key">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_cid')" prop="org_cid">
                            <Input v-model="formData.org_cid" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_cor')" prop="org_cor">
                            <Input v-model="formData.org_cor" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_contact')" prop="link_cname">
                            <Input v-model="formData.link_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_mobile')" prop="link_mobile">
                            <Input v-model="formData.link_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_cname')" prop="cu_cname">
                            <Input v-model="formData.cu_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_mobile')" prop="cu_mobile">
                            <Input v-model="formData.cu_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_ser_time')" prop="cu_ser_time">
                            <Input v-model="formData.cu_time_area" :placeholder="$t('cu_start_time')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="org_level == '2'">
                        <FormItem :label="$t('status')" prop="org_status">
                            <RadioGroup :key="index" v-model="formData.org_status" v-for="(item, index) in org_status">
                                <Radio :label="item.key">{{item.value}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('recv_cor_cname')" prop="recv_cname">
                            <Input v-model="formData.recv_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('phone')" prop="recv_mobile">
                            <Input v-model="formData.recv_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('addrvalue')" prop="addrLabel">
                    <Cascader :data="addrData" :filterable="true" trigger="hover" v-model="formData.addrLabel" @on-change="addrValueChang"></Cascader>
                </FormItem>
                <FormItem :label="$t('org_addr')" prop="org_addr">
                    <Input v-model="formData.org_addr" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('lng')" prop="">
                            <Input v-model="formData.lng" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('lat')" prop="">
                            <Input v-model="formData.lat" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('admin_code')" prop="admin_code">
                            <Input v-model="formData.admin_code" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_admin_code')" prop="org_admin_code">
                            <Input v-model="formData.org_admin_code" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('cdesc')" prop="org_cdesc">
                    <Input v-model="formData.org_cdesc" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('build_img_lnk')" prop="build_img_lnk">
                    <myCropImg :fixedNumber='[660,420]' :autoCropWidthHeight='[660,420]' crop_width="660px" crop_height="420px" @cropImgUpload="setBuildImg"  :original_url="this.formData.build_img_lnk" path="org/build"></myCropImg>
                </FormItem>
                <FormItem :label="$t('cid_img_lnk')" prop="cid_img_lnk">
                    <myUploadCompressedPic @getCompressImgAddr="setCompressImgAddr" path="org/cid"></myUploadCompressedPic>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    import myUploadCompressedPic from '../../../components/myUploadCompressedPic'
    import myCropImg from '../../../components/myCropImg'
    import addr from '../../../utils/addr/index'
    import {msgErr} from "../../../utils/base";
    export default {
        components:{
            myUploadCompressedPic,
            myCropImg
        },
        data:function(){
            return{
                relist:false,
                mods:[],
                formData: {
                    org_id: "",
                    img_lnk: "",
                    org_code: "",
                    org_cname: "",
                    org_status: "1",
                    mod_id: "",
                    org_cid: "",
                    org_cor: "",
                    link_cname: "",
                    link_mobile: "",
                    cu_time_area: "",
                    build_img_lnk: "",
                    cid_img_lnk: "",
                    cu_cname: "",
                    cu_mobile: "",
                    admin_code: "",
                    org_admin_code: "",
                    org_cdesc: "",
                    org_prov: "",
                    org_city: "",
                    org_area: "",
                    org_addr: "",
                    addrLabel:[],
                    lng:'0', // 经度
                    lat:'0',  // 维度
                    org_grade: '',
                    recv_cname: "",
                    recv_mobile: "",
                },
                addrData: [],
                rule: {
                    org_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_status: [{required: true, message: this.$t('input'), trigger: 'change'}],
                    cu_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_prov: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_city: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    mod_id: [{required: true, message: this.$t('input'), trigger: 'change'}],
                    org_area: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addrLabel: [{required: true, message: this.$t('input'), trigger: 'change', type:'array'}],
                },
                org_grade: [],
                org_level: 0,
                org_status: []
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.org_level = this.$base.getRequest().org_level;
            this.getLoad();
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500)
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            setCompressImgAddr: function(compressed_addr){
                this.formData.cid_img_lnk = compressed_addr;
            },
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            getLoad: function(){
                var data = {
                    org_id: this.formData.org_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-down-s0/before-add",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = this.mods.concat(data.mods);
                        this.org_grade = this.org_grade.concat(data.org_grade);
                        this.org_status = this.org_status.concat(data.org_status);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            addrValueChang(value,selectedData){
                this.formData.org_prov = selectedData[0].label;
                if(selectedData.length == 3){
                    this.formData.org_city = selectedData[1].label;
                    this.formData.org_area = selectedData[2].label;
                }
                else if(selectedData.length == 2) {
                    this.formData.org_area = '';
                    this.formData.org_city = selectedData[1].label;
                }
                else if(selectedData.length == 1) {
                    this.formData.org_area = '';
                    this.formData.org_city = '';
                }
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = 'org-down-s0/add';
                        this.formData.org_addr_code = this.formData.addrLabel.join(',');
                        let content = this.$t('org_add_msg');
                        let title =  this.$t('tips');
                        this.$base.confirm(title,content, () => {
                            this.$base.showLoading();
                            this.$request.sendPost(url,this.formData,(success,data,error)=>{
                                this.$base.hideLoading();
                                if(success){
                                    this.$base.msgSuccess(error.errmsg);
                                    this.relist = true;
                                    this.$base.linkBack();
                                }
                                else{
                                    this.$base.msgErr(error.errmsg);
                                }
                            });
                        }, () => {})
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs0_add.vue